import { useEffect } from 'react';

const YoutubeCallback = () => {
  useEffect(() => {
    const code = new URLSearchParams(window.location.search).get('code');
    if (code && window.opener) {
      window.opener.postMessage({ 
        type: 'youtube-auth', 
        code 
      }, window.location.origin);
      window.close();
    }
  }, []);

  return null;
};

export default YoutubeCallback;